import React, { Component } from 'react';
import { connect } from 'react-redux';
import WithdrawModal from './withdrawmodal';
import DepositModal from './depositmodal';
import TransactionModal from './transactionmodal';
import Loader from '../../components/loader';
import ProgressBar from '../../components/progressbar';
import '../../components/balancestyle.scss';

import {
  fetchTransactions,
} from '../../actions';

class TableAsset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: null,
    };
    this.pendingTransactions = this.pendingTransactions.bind(this);
    this.updateDataLooped = this.updateDataLooped.bind(this);
  }

  componentDidMount() {
    const { dispatch, handle } = this.props;
    const data = {
      asset: handle,
      status: 'PENDING',
      tx: true,
    };
    dispatch(fetchTransactions(data))
      .then((res) => {
        if (res.type === 'FETCH_TRANSACTIONS_SUCCESS') {
          this.setState({ transactions: res.payload });
        }
      });

    this.dataLoopInterval = setInterval(this.updateDataLooped, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.dataLoopInterval);
  }

  updateDataLooped() {
    const { dispatch, handle } = this.props;
    const data = {
      asset: handle,
      status: 'PENDING',
      tx: true,
    };
    dispatch(fetchTransactions(data))
      .then((res) => {
        if (res.type === 'FETCH_TRANSACTIONS_SUCCESS') {
          this.setState({ transactions: res.payload });
        }
      });
  }

  pendingTransactions() {
    const { handle, toggleModal, humHandle, assetConf } = this.props;
    const { transactions } = this.state;

    let confirmations = 0;
    let reqConfirmations;

    if (assetConf && assetConf.transfers && assetConf.transfers.confirmations) {
      reqConfirmations = assetConf.transfers.confirmations;
    }
    if (handle === 'LTC') {
      reqConfirmations = 6;
    }

    let depositTrans;

    if (transactions && transactions.length) {
      depositTrans = transactions.filter(function (item) {
        return item.type === 'RECEIVE';
      });
    }

    if (depositTrans && depositTrans[0] && depositTrans[0].txData && depositTrans[0].txData.confirmations) {
      confirmations = depositTrans[0].txData.confirmations;
    }

    let override;

    if (confirmations >= reqConfirmations) {
      override = 90;
      if (depositTrans[0].status === 'VALID') {
        override = 100;
      }
    }

    if (depositTrans && depositTrans.length) {
      return (
        <div className="confirmations">
          <p>
            Transaction Progress
          </p>
          <div className="conf-prog">
            <ProgressBar
              max={reqConfirmations + 1}
              current={confirmations}
              override={override}
            />
            <p>
              {depositTrans[0].quantity}
            </p>
          </div>
          <small
            style={{opacity: 0.5}}
            onClick={() => toggleModal(
              <TransactionModal
                transactions={depositTrans}
                toggleModal={toggleModal}
                humHandle={humHandle}
                handle={handle}
                confirmations={confirmations}
                reqConfirmations={reqConfirmations}
                override={override}
              />, false, true)
            }
          >
            View transactions
          </small>
        </div>
      );
    }
    return (
      null
    );
  }

  currencySign(val) {
    if (val === 'EURCENT' || val === 'EUR' || val === 'VEUR') {
      return '\u20AC';
    }
    if (val === 'CENT' || val === 'USD' || val === 'VUSD') {
      return '\u0024';
    }
    if (val === 'GBP' || val === 'VGBP') {
      return '\u00A3';
    }
  }

  toLocaleFixed(num, dec) {
    let localeFixed;
    let number = '0';
    if (num) {
      number = num;
    }
    const formatter = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: dec,
      maximumFractionDigits: dec,
    });
    if (number && dec) {
      localeFixed = formatter.format(number);
    }
    return localeFixed;
  }

  render() {
    const { user, useKey, handle, humHandle, urlAsset, description, assetPending, assetSettled, assetNet, decimal, withEnabled, depEnabled, otpEnabled, otpErr, userVerified, toggleModal, sendDefaults, receiveDefaults, assetConf, erc20 } = this.props;
    const { transactions } = this.state;

    const hasPending = assetPending || assetPending === 0;
    const hasSettled = assetSettled || assetSettled === 0;
    const hasNet = assetNet || assetNet === 0;

    const loaded = handle && hasPending && hasSettled && hasNet;

    let isFiat;
    if (handle === 'VEUR' || handle === 'VGBP') {
      isFiat = true;
    }

    let userCurrencyHandle;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      userCurrencyHandle = user.me.defaults.currencyHandle;
    }

    if (loaded) {
      return (
        <tr className={'asset-row ' + urlAsset.toLowerCase()} key={useKey}>

          <td className="at-d">
            <div className="ar-name">
              <div className={'ar-coin card-coin ' + urlAsset.toLowerCase()}>
                <img alt={humHandle} src={ process.env.REACT_APP_CDN + '/assets/icons/assets/' + urlAsset.toLowerCase() + '.svg'} />
              </div>
              <div className="ar-detail">
                <h3 className="ar-title">
                  {humHandle}
                  <span className="hide-mob"> ({handle})</span>
                </h3>
                <div className="ar-description mute">
                  <span className="hide-mob">{description}</span>
                  <span className="show-mob">{handle}</span>
                </div>
              </div>
            </div>
          </td>

          <td className="at-m">
            <div className="ar-name">
              <div className={'ar-coin card-coin ' + urlAsset.toLowerCase()}>
                <img alt={humHandle} src={ process.env.REACT_APP_CDN + '/assets/icons/assets/' + urlAsset.toLowerCase() + '.svg'} />
              </div>
              <div className="ar-detail">
                <h3 className="ar-title">
                  {isFiat ? (
                    <>
                      {this.currencySign(handle)}
                      { assetSettled ? (
                        this.toLocaleFixed(assetSettled, 2)
                      ) : (
                        Number('0').toFixed(2)
                      )}
                    </>
                  ) : (assetSettled)}
                </h3>
                <div className="ar-description mute">
                  {humHandle}
                </div>
              </div>
            </div>
          </td>

          <td className="at-d">
            {isFiat ? (
              <>
                {this.currencySign(userCurrencyHandle)}
                { assetSettled ? (
                  this.toLocaleFixed(assetSettled, 2)
                ) : (
                  Number('0').toFixed(2)
                )}
              </>
            ) : (assetSettled)}
          </td>

          <td>
            <div className="ar-buttons">
              <button
                type="button"
                className="vlt-button dark-b"
                disabled={!depEnabled || (handle === 'TST') || (handle === 'DASH')}
                onClick={() => toggleModal(
                  <DepositModal
                    toggleModal={toggleModal}
                    modalComponent={this.state.modalComponent}
                    asset={handle}
                    humAsset={humHandle}
                    urlAsset={urlAsset}
                    assetPending={assetPending}
                    assetSettled={assetSettled}
                    assetNet={assetNet}
                    decimal={decimal}
                    sendDefaults={sendDefaults}
                    receiveDefaults={receiveDefaults}
                    assetConf={assetConf}
                    erc20={erc20}
                  />, true, false)
                }
              >
                <span>
                  Deposit
                </span>
              </button>
              <button
                type="button"
                className="vlt-button dark-b"
                disabled={!withEnabled}
                onClick={() => toggleModal(
                  <WithdrawModal
                    toggleModal={toggleModal}
                    modalComponent={this.state.modalComponent}
                    asset={handle}
                    humAsset={humHandle}
                    urlAsset={urlAsset}
                    assetPending={assetPending}
                    assetSettled={assetSettled}
                    assetNet={assetNet}
                    decimal={decimal}
                    sendDefaults={sendDefaults}
                    receiveDefaults={receiveDefaults}
                    assetConf={assetConf}
                    erc20={erc20}
                  />, true, false)
                }
              >
                <span>
                  Withdraw
                </span>
              </button>
            </div>
            { !withEnabled || !depEnabled ? (
              <div className="otp-err">
                {otpErr}
              </div>
            ) : null }
          </td>

        </tr>
      );
    }

    return (
      <tr className="asset-table" key={useKey}>
        <td colSpan="3">
          <div className="center-loader">
            <Loader logo small />
          </div>
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  // transactions: state.coins.transactions,
  // errors: state.transactions.errors,
});

export default connect(mapStateToProps)(TableAsset);
